import {
  IconButton,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@material-ui/core';
import React from 'react';
import Edit from '@material-ui/icons/Edit';
import { useStyles } from '../../../../styles';

const SLATransactionsTable = ({ onEdit, allTransactions }) => {
  const classes = useStyles();

  return (
    <>
      <TableContainer component={Paper}>
        <Table
          size="small"
          className={classes.table}
          aria-label="a dense table"
        >
          <TableHead>
            <TableRow classes={{ root: classes.tableHead }}>
              <TableCell className={classes.dateTimeTableCell}>
                <Typography
                  classes={{ root: classes.tableHeadCell }}
                  variant="subtitle2"
                >
                  Transaction
                </Typography>
              </TableCell>
              <TableCell>
                <Typography
                  classes={{ root: classes.tableHeadCell }}
                  variant="subtitle2"
                >
                  Expected response time
                </Typography>
              </TableCell>
              <TableCell />
            </TableRow>
          </TableHead>
          <TableBody>
            {allTransactions &&
              allTransactions.length > 0 &&
              allTransactions.map((transaction: any, index: number) => (
                <TableRow
                  classes={{ root: classes.configTableRow }}
                  key={index}
                >
                  <TableCell
                    classes={{
                      root: `${classes.tableBodyCell} ${classes.clickableTableCell}`,
                    }}
                  >
                    <Typography variant="subtitle2">
                      {transaction?.transactionName}
                    </Typography>
                  </TableCell>
                  <TableCell classes={{ root: classes.tableBodyCell }}>
                    {transaction?.expectedResponseTime}
                  </TableCell>
                  <TableCell className={classes.actionButtonInTableCell}>
                    <IconButton className={classes.actionButtonRun}>
                      <Edit
                        onClick={() => onEdit('editTransaction', transaction)}
                      />
                    </IconButton>
                  </TableCell>
                </TableRow>
              ))}
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
};

export default SLATransactionsTable;
